module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container",
    staticStyle: {
      "height": "500px"
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }), _vm._v(" "), (!_vm.showZdgc) ? _c('div', [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("暂无指导过程数据")])]) : _vm._e(), _vm._v(" "), (_vm.showZdgc) ? _c('div', [_c('el-descriptions', {
    staticClass: "margin-top",
    attrs: {
      "column": 3,
      "border": ""
    }
  }, [_c('el-descriptions-item', {
    attrs: {
      "label-style": {
        'width': '12.2%'
      },
      "label": "题目"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.xt))])], 1), _vm._v(" "), _c('el-descriptions', {
    staticClass: "margin-top",
    attrs: {
      "column": 3,
      "border": ""
    }
  }, [_c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_vm._v("\n                    年份\n                ")]), _vm._v("\n                " + _vm._s(_vm.curdForm.nf) + "\n            ")], 2), _vm._v(" "), _c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_vm._v("\n                    专业\n                ")]), _vm._v("\n                " + _vm._s(_vm.curdForm.zymc) + "\n            ")], 2), _vm._v(" "), _c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_vm._v("\n                    班级\n                ")]), _vm._v("\n                " + _vm._s(_vm.curdForm.bjmc) + "\n            ")], 2), _vm._v(" "), _c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_vm._v("\n                    学生\n                ")]), _vm._v("\n                " + _vm._s(_vm.curdForm.xm) + "\n            ")], 2), _vm._v(" "), _c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_vm._v("\n                    学号\n                ")]), _vm._v("\n                " + _vm._s(_vm.curdForm.xh) + "\n            ")], 2), _vm._v(" "), _c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_vm._v("\n                    指导教师\n                ")]), _vm._v("\n                " + _vm._s(_vm.curdForm.zdjs) + "\n            ")], 2)], 1), _vm._v(" "), _vm._l((_vm.options), function(option, index) {
    return _c('div', {
      staticStyle: {
        "margin-top": "30px"
      }
    }, [_c('el-descriptions', {
      staticClass: "margin-top",
      attrs: {
        "column": 3,
        "border": ""
      }
    }, [_c('el-descriptions-item', {
      attrs: {
        "label": "标题"
      }
    }, [_vm._v(_vm._s(option.gradeDesignFile.lx))]), _vm._v(" "), _c('el-descriptions-item', {
      attrs: {
        "label": "附件"
      }
    }, [_vm._v("\n                    " + _vm._s(option.gradeDesignFile.wjm) + "\n                    "), _c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.downloadRec(option)
        }
      }
    }, [_vm._v("查看文件")])], 1), _vm._v(" "), _c('el-descriptions-item', {
      attrs: {
        "label": "提交时间"
      }
    }, [_vm._v(_vm._s(option.gradeDesignFile.cjsj))]), _vm._v(" "), _c('el-descriptions-item', {
      attrs: {
        "label": "指导教师建议",
        "contentClassName": "zdjsyj"
      }
    }, [_vm._v(_vm._s(option.jsyj))]), _vm._v(" "), _c('el-descriptions-item', {
      attrs: {
        "label": "提交时间"
      }
    }, [_vm._v(_vm._s(option.cjsj))])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b45526b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/scoreManage/register/GuidanceProcess.vue
// module id = 1841
// module chunks = 502